export interface ITicketSoporteClientePagingRes {
  count: number;
  next: null;
  previous: null;
  numero_paginas: number;
  data: ITicketSoporteCliente[];
}

export interface ITicketSoporteCliente {
  id_ticket_soporte?: string;
  
  estado: boolean
  codigo?: string
  numero_referencia?: string
  fecha_apertura?: string,
  fecha_apertura_after?: string,
  fecha_apertura_before?: string,
  fecha_fin?: string,
  tiempo_transcurrido?: string,
  canal_comunicacion: string,
  observaciones: any,
  nombre_contacto: string,
  telefono_contacto: string,
  parentesco_contacto: string,
  estado_solucion?: string,
  estado_ticket?: string,
  ticket_cerrado?: boolean,
  informacion_solucion: any,
  cliente: string,
  contrato: string,
  categoria: string,
  subcategoria: string,
  causal: string
  departamento_responsable?:string
}





export enum TIPO_FILTRO_TICKET {
  IDENTIFICACION = 'IDENTIFICACIÓN',
  RAZON_SOCIAL = 'RAZÓN SOCIAL',
  NUMERO_TICKET = 'NÚMERO DE TICKET',
}

export enum ESTADO_TICKET {
  ABIERTO = 'ABIERTO',
  EN_ESPERA = 'EN ESPERA',
  CERRADO = 'CERRADO',
  EN_PROCESO = 'EN PROCESO',
  FINALIZADO = 'FINALIZADO',
  CANCELADO = 'CANCELADO',
  ESCALADO = 'ESCALADO',
  RESPONDIDO = 'RESPONDIDO',
  RESUELTO = 'RESUELTO',
}


export enum ESTADO_SOLUCION {
  PENDIENTE = 'PENDIENTE',
  EN_PROCESO = 'EN PROCESO',
  FINALIZADO = 'FINALIZADO',
  CANCELADO = 'CANCELADO',
}

export enum TIPO_FILTRO_TICKET_CLIENTE{
  RAZON_SOCIAL = 'RAZÓN SOCIAL',
  EMAIL = 'EMAIL',
  DIRECCION = 'DIRECCIÓN',
   //NUMERO_TICKET = 'NÚMERO DE TICKET',
}

export const CHOICE_TIPO_FILTRO_TICKET = [
  TIPO_FILTRO_TICKET.IDENTIFICACION,
  TIPO_FILTRO_TICKET.RAZON_SOCIAL,
  TIPO_FILTRO_TICKET.NUMERO_TICKET,
]

export const CHOICE_ESTADO_TICKET = [
  ESTADO_TICKET.ABIERTO,
  ESTADO_TICKET.EN_ESPERA,
  ESTADO_TICKET.CERRADO,
  ESTADO_TICKET.EN_PROCESO,
  ESTADO_TICKET.FINALIZADO,
  ESTADO_TICKET.CANCELADO,
  ESTADO_TICKET.ESCALADO,
  ESTADO_TICKET.RESPONDIDO,
  ESTADO_TICKET.RESUELTO,
]

export const CHOICE_ESTADO_SOLUCION = [
  ESTADO_SOLUCION.PENDIENTE,
  ESTADO_SOLUCION.EN_PROCESO,
  ESTADO_SOLUCION.FINALIZADO,
  ESTADO_SOLUCION.CANCELADO,
]
export const CHOICE_TIPO_FILTRO_TICKET_CLIENTE = [
  TIPO_FILTRO_TICKET_CLIENTE.RAZON_SOCIAL,
  TIPO_FILTRO_TICKET_CLIENTE.EMAIL,
  //TIPO_FILTRO_TICKET_CLIENTE.NUMERO_TICKET,
  TIPO_FILTRO_TICKET_CLIENTE.DIRECCION,
]




